<template>
  <div class="QuestionAnsweringManagementContainer" >

    <div class="form">
      <el-form ref="form" :inline="true" label-width="100px" :model="form" @submit.native.prevent >
        <div style="display: flex; justify-content: space-between;" >
          <div>
            <el-form-item label="问题内容" prop="keyword" >
              <el-input v-model="form.keyword" clearable placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item prop="status" >
              <el-radio-group v-model="form.status" >
                <template v-for="(item,index) in statusRadioList" >
                  <el-radio :key="index" :label="item.value" border>{{ item.label }}</el-radio>
                </template>
              </el-radio-group>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button type="primary" @click="onSubmit" native-type="submit" >查询</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <div class="list">
      <div class="add">
        <el-button type="primary" @click="addFn" size="small" >新增答疑</el-button>
      </div>
      <el-table
          :data="table"
          v-loading="tableLoad"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          style="width: 100%">
        <el-table-column
            prop="createNo"
            align="center"
            label="创建序号"
            width="160"
            >
        </el-table-column>
        <el-table-column
            prop="createTimeStr"
            align="center"
            width="160"
            label="创建时间">
        </el-table-column>
        <el-table-column
            prop="status"
            align="center"
            width="160"
            label="当前状态">
          <template #default="{ row }" >
            <span class="statusClass" :style="{ '--color': statusName(row).color }" >{{ statusName(row).label }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="sort"
            align="center"
            width="160"
            label="当前排序">
        </el-table-column>
        <el-table-column
            prop="question"
            align="center"
            label="问题内容">
        </el-table-column>
        <el-table-column
            prop="answer"
            align="center"
            label="回复问题">
          <template #default="{ row }" >
            <div v-html="row.answer" class="answerClass" ></div>
          </template>
        </el-table-column>
        <el-table-column
            width="160"
            fixed="right"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="editFn(scope.row)" >编辑</el-button>
            <template v-if="scope.row.status == '0'" >
              <el-button type="text" size="small" @click="statusFn(scope.row)" >启用</el-button>
            </template>
            <template v-else >
              <el-button type="text" size="small" @click="statusFn(scope.row)" >停用</el-button>
            </template>
            <el-popconfirm
                style="margin-left: 10px;"
                title="删除后将不可取消，小程序将不再显示该答疑，确定删除吗？"
                @confirm="delHandler(scope.row)">
              <el-button slot="reference" type="text" size="small" >删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="form.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="form.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

    <AddQuestionAnsweringManagement v-model="AddData.show" :id="AddData.id" @updateList="getList" @delHandler="delHandler" />

  </div>
</template>

<script>
import AddQuestionAnsweringManagement from "./components/AddQuestionAnsweringManagement";
export default {
  name: "QuestionAnsweringManagement",
  components: {
    AddQuestionAnsweringManagement,
  },
  data() {
    return {
      form: {
        pageNum: 1,
        pageSize: 10,
        keyword: "",
        status: "",
      },
      statusRadioList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "启用",
          color: "#00D319",
        },
        {
          value: "0",
          label: "禁用",
          color: "#DD0000",
        },
      ],
      table: [],
      tableLoad: true,
      total: 0,
      AddData: {
        show: false,
        id: "",
      }
    }
  },
  computed: {
    statusName() {
      return function (row) {
        let obj = {};
        const status = row.status.toString(),
              arr = (this.statusRadioList || []).filter(item => item.value === status);
        if (arr && arr.length > 0) {
          obj = arr[0];
        }
        return obj;
      }
    }
  },
  created() {
    this.getList();
  },
  mounted() {

  },
  methods: {
    addFn() {
      this.AddData.id = "";
      this.AddData.show = true;
    },
    editFn(row) {
      this.AddData.id = row.id;
      this.AddData.show = true;
    },
    async statusFn(row) {
      try {
        const res = await this.$get("qa/status", {
          id: row.id,
          status: row.status == "1" ? "0" : "1",
        })
        if (!res) return false;
        await this.getList();
      }catch (e) {
        console.error(`切换失败`, e);
      }
    },
    async delHandler(row) {
      try {
        const res = await this.$get("qa/deleteById", {
          id: row.id
        })
        if (!res) return false;
        await this.getList();
      }catch (e) {
        console.error(`删除失败`, e);
      }
    },
    async getList() {
      try {
        const res = await this.$get("qa/list",this.form);
        if (!res) return false;
        const { data } = res;
        this.total = data.total;
        this.table = data.records;
        console.log(`获取智能答疑列表成功`, data);
      }catch (e) {
        console.error(`获取智能答疑列表失败`, e);
      }finally {
        this.tableLoad = false;
      }
    },
    onSubmit() {
      this.form.pageNum = 1;
      this.getList();
    },
    handleSizeChange(e) {
      this.form.pageNum = 1;
      this.form.pageSize= e;
      this.getList();
    },
    handleCurrentChange(e) {
      this.form.pageNum= e;
      this.getList();
    },
  }
}
</script>

<style scoped lang="scss">
.el-radio.is-bordered{
  margin: 0!important;
  border-radius: 0;
  :deep(.el-radio__input) {
    display: none;
  }
}
.statusClass{
  color: var(--color);
}
.answerClass{
  max-height: 50px;
  overflow: hidden;
  :deep(img) {
    width: 30px;
  }
}
.guide-video {
  width: 100%;
  
}
</style>
